const WhyChooseUs = () => {
  const features = [
    {
      icon: 'ri-star-line',
      title: 'Experiencia Local',
      description: 'Más de 15 años especializados en pavimentos decorativos y piscinas en la Costa del Sol',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Acabados Premium',
      description: 'Materiales de primera calidad con acabados resistentes, decorativos y antideslizantes certificados',
    },
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Proyectos Personalizados',
      description: 'Diseños únicos adaptados a cada cliente, desde viviendas particulares hasta grandes comunidades',
    },
    {
      icon: 'ri-building-line',
      title: 'Todo Tipo de Obras',
      description: 'Trabajamos en viviendas, comunidades, locales comerciales y obra nueva con la misma excelencia',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-secondary text-sm mb-3">(Nuestra diferencia)</p>
          <h2 className="text-5xl font-bold text-dark">
            Por qué confiar en
            <br />
            <span className="text-primary">HORMI PREMIUM</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-5xl text-primary`}></i>
              </div>
              <h3 className="text-xl font-semibold text-dark mb-3">{feature.title}</h3>
              <p className="text-secondary leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;